import { LoadingButton } from "@mui/lab";
import { Box, Typography } from "@mui/material";
import { useContent } from "../../content/useContent";
import { Colors } from "../../theme/colors";
import { darkModeField, darkModePassword } from "../../theme/darkModeInput";
import FormikInput from "../Form/FormikInput";
import FormikPassword from "../Form/FormikPassword";

type IProps = {
  formik: any;
  loading: boolean;
  setShowResetEmail: React.Dispatch<React.SetStateAction<boolean>>;
};

const classes = {
  description: {
    marginBottom: "30px",
    lineHeight: "79.2px",
    fontSize: "32px",
    fontWeight: "700",
  },
  btn: {
    height: "66px",
    width: "100%",
    fontWeight: "600",
    fontSize: "18px",
  },
  forgetPassword: {
    display: "flex",
    justifyContent: "flex-end",
    margin: "12px 0",
    width: "100%",
    "&:hover": {
      cursor: "pointer",
      textDecoration: "underline",
      textDecorationColor: Colors.secondary,
    },
  },
};

const LoginForm: React.FC<IProps> = ({
  formik,
  loading,
  setShowResetEmail,
}) => {
  const { login } = useContent().pages;

  return (
    <>
      <Typography
        variant="h1"
        component="h1"
        color="secondary"
        sx={classes.description}
      >
        {login.title1}
      </Typography>

      <FormikInput
        formik={formik}
        name="username"
        label={login.email}
        sx={darkModeField}
      />

      <FormikPassword
        color="secondary"
        label={login.password}
        formik={formik}
        sx={darkModePassword}
      />

      <Box sx={classes.forgetPassword}>
        <Typography
          onClick={() => setShowResetEmail(true)}
          variant="body2"
          component="p"
          color="secondary"
        >
          {login.forgot}
        </Typography>
      </Box>

      <LoadingButton
        variant="contained"
        color="secondary"
        onClick={formik.handleSubmit}
        loading={loading}
        sx={classes.btn}
      >
        {login.log}
      </LoadingButton>
    </>
  );
};

export default LoginForm;
